import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconInsumoBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'

function InsumoMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.INSUMO, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    { id: 107, content: { menu: '7.1 - Insumo', path: '/main/insumo/cadastro-insumo' } },
    {
      id: 108,
      content: {
        menu: '7.2 - Entrada e Saída - Insumo',
        path: '/main/insumo/entrada-saida-insumo',
      },
    },
    {
      id: 109,
      content: { menu: '7.3 - Painel Insumo', path: '/main/insumo/painel-insumo' },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconInsumoBlue} alt="Icon Tela de Insumo" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>7. Insumo</span>
      </PageMenu>
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(InsumoMenu))
